import { useHistory } from "react-router-dom";
import { SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY } from "../../../../../sessionStorage";

export default function HowToPurchaseData() {
  let history = useHistory();
  return {
    title: 'Purchasing This Product Can Be Simple',
    paragraphs: [
      `Visit the dynamic term quoting tool to explore products and initiate the insurance case for your client: <a id="term-link" class="redirect-link">Term Life Insurance Quoting Tool</a>`,
    ],
    linkId: 'term-link',
    onLinkClick : () => {
        sessionStorage.removeItem(SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY);
        history.push('/Products/Term');
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/term/HowToPurchaseData.js